import React from "react";
import GenericTabs from "../../common/TabPanel/GenericTabs";
import { tabsData } from "../../constants/tabsData";
import { useTabValue } from "../../../store/plateWellStore";

const Qlp96WellMetricsDisplay = () => {  //plate_uuid is passed in from Qlp96WellMetricsList.jsx

    const tabValue = useTabValue();
    // const tabsData = [

    //     {
    //         label: 'Display Settings',
    //         //  content: <div>Display Settings Content</div>
    //     },
    //     {
    //         label: 'Info/Consumable',
    //         //  content: <div>Consumable Settings Content</div>
    //     },
    //     {
    //         label: 'Analysis',
    //         // content: <div>Analysis Settings</div>
    //     },
    //     {
    //         label: 'Analysis Results',
    //         // content: <div>Analysis Result Settings</div>
    //     },
    //     {
    //         label: 'Actions',
    //         //  content: <div>Action Settings</div>
    //     },

    // ]

    return (
        <div key={crypto.randomUUID()}>
            <GenericTabs tabsData={tabsData} tabValue={tabValue} />
        </div>
    );
}

export default Qlp96WellMetricsDisplay;